import type { AcceptorBase as MysteryAcceptor } from '@mobi/betslip/types'
import type { NoveltySelections } from '@core/Areas/Quickbet/Components/BetSelectionInfo/types'

export function parseRawNoveltySelectionString({
  selectionString,
  isAllways,
  isLegIn,
  isRovingBanker,
  acceptorsForRace,
}: {
  selectionString: string
  isAllways: boolean
  isLegIn: boolean
  isRovingBanker: boolean
  acceptorsForRace: MysteryAcceptor[]
}): NoveltySelections {
  const parts = selectionString
    .split('/')
    .map(part => addAcceptorNameToSingleSelection(part, acceptorsForRace))
  if (isAllways) {
    return { ALLWAYS: parts[0] }
  }

  if (isRovingBanker) {
    return {
      RB: parts[0],
      WITH: parts[1],
    }
  }

  if (isLegIn) {
    return {
      'LEG-IN': parts[0],
      WITH: parts[1],
    }
  }

  return {
    '1st': parts[0],
    '2nd': parts[1],
    '3rd': parts[2],
    '4th': parts[3],
  }
}

export function addAcceptorNameToSingleSelection(
  selectionForRace: string,
  acceptorsForRace: MysteryAcceptor[]
): string {
  if (selectionForRace && /^\d+$/.test(selectionForRace)) {
    const acceptor = getAcceptorName(selectionForRace, acceptorsForRace)

    if (acceptor) {
      return `${selectionForRace} - ${acceptor}`
    }
  }

  return selectionForRace
}

function getAcceptorName(acceptorNumber: string, acceptorsForRace: MysteryAcceptor[]): string {
  const acceptor = acceptorsForRace.find(x => `${x.number}` === acceptorNumber)
  return acceptor ? acceptor.name : ''
}
